import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

const configPinia = () => {
  const pinia = createPinia();
  pinia.use(
    createPersistedState({
      storage: sessionStorage,
    }),
  );
  return pinia;
};

export default configPinia;
